// extracted by mini-css-extract-plugin
export default {"axnuiExplicitConsentContainer":"axnui-explicit-consent-container__axnui-explicit-consent-container__iawps"};